import VCheckbox from './VCheckbox';
export { VCheckbox };
export default VCheckbox;
//# sourceMappingURL=index.js.map